import React, { Component } from 'react'
import Banner from '../components/Images/Banner/Banner'

import banner1 from '../../assets/images/contact-us/mfg-contact_us-min.png'

import styles from './contact-us.module.less'
import { navigateTo } from 'gatsby-link'

// email field validation
const VALID_EMAIL_PATTERN = /(^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+\w$)/
const isValidEmail = value => {
  return VALID_EMAIL_PATTERN.test(value)
}

class ContactUs extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isEmailValid: false,
      emailInput: ''
    }

    this.handleChange = this.handleChange.bind(this)
    this.handleReset = this.handleReset.bind(this)
  }

  handleChange(e) {
    const emailInput = e.target.value

    if (isValidEmail(emailInput)) {
      this.setState({
        isEmailValid: true,
        emailInput
      })
    } else {
      this.setState({
        isEmailValid: false,
        emailInput
      })
    }
  }

  // not working in IE11, perhaps with 'onClick' polyfill?
  handleReset(e) {
    e.preventDefault()

    document.getElementById('contact-form-v2').reset()

    this.setState({
      isEmailValid: false,
      emailInput: ''
    })
  }

  handleFormSubmission(e) {
    e.preventDefault();
    let myForm = document.getElementById('contact-form-v2');
    let formData = new FormData(myForm);
    fetch("/", {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams(formData).toString(),
    })
      .then(() => {
        console.log('Form Submitted');
        navigateTo('/success-contact-us');
      })
      .catch(() => {});
  }

  render() {
    const { isEmailValid, emailInput } = this.state

    return (
      <div className={styles.contactUsContainer}>
        <Banner src={banner1} caption='Build With Us.' />

        <div className={styles.stdContent}>
          <div className={styles.left}>
            <h2>Email Us</h2>
            <p>To find out if a relationship with Empire is right for you, please contact us today.</p>
            <form
              id='contact-form-v2'
              name='contact'
              method='POST'
              data-netlify='true'
              data-netlify-recaptcha='true'
              netlify-honeypot="bot-field"
            >
              <div className={styles.section}>
                <input type="hidden" name="form-name" value="contact" />
                <div className={styles.field}>
                  <label htmlFor='name'>Full Name</label>
                  <input id='name' name='name' type='text' />
                </div>

                <div className={styles.field}>
                  <label htmlFor='company'>Company</label>
                  <input id='company' name='company' type='text' />
                </div>

                <div className={styles.field}>
                  <label htmlFor='email'>Email Address</label>
                  <input id='email' name='email' type='email' value={emailInput} onChange={this.handleChange} />
                </div>


                <div className={styles.field}>
                  <label htmlFor='questions-comments'>Questions / Comments</label>
                  <textarea id='questions-comments' name='questions-comments' />
                </div>

                <div className={styles.field}>
                  <p className={styles.recaptcha}>Please check reCAPTCHA box before clicking Submit.</p>
                </div>

                <div data-netlify-recaptcha='true'></div>

                <div className={styles.field}>
                  <button
                    className={isEmailValid ? styles.submit : styles.disabled}
                    type='submit'
                    disabled={!isEmailValid}
                    title='Please submit with a valid email address'
                    onClick={this.handleFormSubmission}
                  >
                    Submit
                  </button>
                  <button type='button' className={styles.clear} onClick={this.handleReset}>Clear</button>
                </div>
              </div>
            </form>
          </div>
          <div className={styles.right}>
            <h2>Our Office</h2>
            <div className={styles.map}>
              <iframe src="https://maps.google.com/maps?q=101+Crawfords+Corner+Road+Suite+3128+Holmdel+NJ+07733&output=embed" width="588" height="300" frameBorder="0" style={{ border: '0' }} allowFullScreen></iframe>
            </div>
            <div className={styles.section}>
              <div className={styles.address}>
                <div>
                  <label>Address:</label>
                  <p>101 Crawfords Corner Road</p>
                  <p>Suite 3128</p>
                  <p>Holmdel NJ 07733</p>
                </div>
                <div>
                  <label>Phone:</label>
                  <p>888.417.8050</p>
                  <p>212.417.7777</p>
                </div>
                <div>
                  <label>Email:</label>
                  <p><a href='mailto:info@empiream.com'>info@empiream.com</a></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ContactUs



// WEBPACK FOOTER //
// ./src/pages/contact-us.js